
import * as React from "react";
import { Api } from "../../../lib/Api";
import { IUserRegisrationData } from "../../../interfaces/IUser";
import AddressBox, { ICountryOption } from "../../global/AddressBox";
import { Lng } from "../../../../languages/Languages";
import RegCheckboxes from "../../global/RegCheckboxes";
import { ISetUrl } from "../../../AppMain";
import LoaderComp from "../../../../avernus/loader/source/LoaderComp";

export interface IRegistrationSaveUser{
    success               : string
    error                 : string
    userName              : string
    password              : string
    socUserLoginNotFounded?: string
    foundedUser           : boolean
}

type IType = 'user'|'professional';

interface IUserRegistrationProps {
    title                       : string
    type                        : IType
    successRegistration         : IsuccessRegistration
    setUrl:ISetUrl
}

interface IsuccessRegistration{
    (email:string, password:string):void
}


interface IUserRegistrationState extends IInitResult {
    success             : string
    error               : string
    form                : any
    loading             : boolean
    acceptedAll         : boolean
}

interface IOption{
    label: string
    value: number
}

interface IInitResult{
    restaurantTypeOptions: Array<IOption>
    countryOptions       : Array<ICountryOption>
}

export default class UserRegistration extends React.Component<IUserRegistrationProps, IUserRegistrationState>{

    constructor(props:IUserRegistrationProps){
        super(props);
        this.state = {
            success                 : null,
            error                   : null,
            acceptedAll             : false,
            form                    : {
                lastName        : '',
                firstName       : '',
                userName        : '',
                phone           : '',
                email           : '',
                password        : '',


                addressCountry  : '',
                addressState    : '',
                addressCity     : '',
                addressStreet   : '',
                addressZip      : '',
                longitude       : '',
                latitude        : '',
                type            : 'user'
            },
            loading                 : false,
            restaurantTypeOptions   : null,
            countryOptions          : null
        };
        this.init();
    }

    private init(){
        Api.call('/registrationInit', {}, (initResult:IInitResult)=>{
            this.setState({
                countryOptions       : initResult.countryOptions
            });
        });
    }

    private submitHandler(evt): void {
        evt.preventDefault();
        let saveData:any        = this.state.form;
        saveData.loginMethod = 'reg';
        saveData.type = this.props.type;
        saveData.permission = this.props.type == "professional" ? "manager" : "user";
        Api.call('/registration', saveData, (result)=>{
            if ( result.success) {
                this.props.successRegistration(this.state.form.userName, this.state.form.password);
            } else {
                let error = result.error;
                if ( result.tokenError !== undefined ) {
                    error = result.tokenError?'Wrong token':'';
                }
                this.setState({
                    error: result.error,
                    loading: false
                });
            }
        });
    }

    private changeInputHandler(evt, type:string): void {
        evt.preventDefault();
        let form = this.state.form;
        form[type] = evt.target.value;
        this.setState({
            form: form
        });
    }

    render() {
        return (
            <>
                <form onSubmit={ e => this.submitHandler(e) }>
                    { this.props.children }
                    <div className="row service-registration-box">
                        <div className="col-12">
                            <div className="form-row">
                                <div className="col">
                                    <input className="s-form-control" type="text" name="firstName" value={this.state.form.firstName} onChange={ e => this.changeInputHandler(e,'firstName') } placeholder={Lng.get('userreg_firstname')} required={true}/>
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="col">
                                    <input className="s-form-control" type="text" value={this.state.form.lastName} onChange={ e => this.changeInputHandler(e,'lastName') }
                                            name="lastName" placeholder={Lng.get('userreg_lastname')} required={true} />
                                </div>
                            </div>

                            <div className="form-row">
                                <div className="col">
                                    <input className="s-form-control" type="email" placeholder="E-mail" name="email" value={this.state.form.email} onChange={ e => this.changeInputHandler(e,'email') } />
                                </div>
                            </div>

                            <div className="form-row">
                                <div className="col">
                                    <input className="s-form-control" type="text" placeholder="Phone" name="email" value={this.state.form.phone} onChange={ e => this.changeInputHandler(e,'phone') } />
                                </div>
                            </div>

                            { this.props.type == 'professional' &&
                                <div className="form-row">
                                    <div className="col">
                                        <input className="s-form-control" type="text" placeholder={Lng.get('userreg_phone')} name="phone" value={this.state.form.phone} onChange={ e => this.changeInputHandler(e,'phone') } />
                                    </div>
                                </div>
                            }

                            <div className="form-row">
                                <div className="col">
                                    <input className="s-form-control" type="text" placeholder={Lng.get('userreg_username')} name="userName"  autoComplete="off" value={this.state.form.userName} onChange={ e => this.changeInputHandler(e,'userName') } required={true} />
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="col">
                                    <input className="s-form-control" placeholder={Lng.get('userreg_password')} type="password" name="password" minLength={8}  autoComplete="off" value={this.state.form.password} onChange={ e => this.changeInputHandler(e,'password') } required={true}/>
                                </div>
                            </div>

                            <div id="er_address">
                                { this.state.countryOptions ? <AddressBox
                                    key={'address_box'}
                                    title=''

                                    countryOptions={this.state.countryOptions}
                                    addressCountry={this.state.form.addressCountry}
                                    addressState={this.state.form.addressState}
                                    addressCity={this.state.form.addressCity}
                                    addressStreet={this.state.form.addressStreet}
                                    addressZip={this.state.form.addressZip}

                                    changed={ (ret) => {
                                        let form            = this.state.form;
                                        form.addressCountry = ret.addressCountry;
                                        form.addressState   = ret.addressState;
                                        form.addressCity    = ret.addressCity;
                                        form.addressStreet  = ret.addressStreet;
                                        form.addressZip     = ret.addressZip;
                                        this.setState({
                                            form: form
                                        });
                                    } }
                                />: <LoaderComp show={true} /> }
                            </div>
                        </div>
                    </div>

                    <RegCheckboxes
                        privacyPolicyAccepted={0}
                        aszfAccepted={0}
                        setUrl={this.props.setUrl}
                        changed={(acceptedAll, form) => {
                            this.setState({
                                acceptedAll: acceptedAll
                            });
                        }}
                    />
                    <br />
                    <br />
                    { this.state.error !== null || this.state.success !== null?<>
                        <div className="form-row" style={{
                            marginTop: '15px'
                        }}>
                            <div className="col-sm-12">
                                { this.state.error !== null?<div className="alert alert-danger">
                                        { this.state.error }
                                </div>:''}
                                { this.state.success !== null?<div className="alert alert-success">
                                        { this.state.success }
                                </div>:''
                                }
                            </div>
                        </div>
                    </>:'' }


                    <div className="row">
                        <div className="col-12">
                            <button className="green_btn btn-block" id="user_save_btn" type="submit" disabled={!this.state.acceptedAll}>{Lng.get('userreg_regbtn')}</button>
                        </div>
                    </div>

                </form>
            </>
        );
    }
}
